import { RefObject, useRef, useState } from 'react'
import { useIntersectionObserver } from './useIntersectionObserver'

export const useInView = <T extends HTMLElement>(
  options?: IntersectionObserverInit,
  onInView?: (inview: boolean) => void,
  triggerAlways?: boolean
): { ref: RefObject<T>; inView: boolean } => {
  const ref = useRef<T>(null)
  const [inView, setInView] = useState(false)
  useIntersectionObserver<T>(
    ref,
    (entries): void =>
      entries.forEach((entry): void => {
        const isVisible = entry.isIntersecting
        setInView(isVisible)
        if (onInView) onInView(isVisible)
      }),
    options,
    triggerAlways || !inView
  )

  return { ref, inView }
}
